/* eslint-disable @next/next/no-img-element */

import { OffenseFragment } from '@amf/shared/types/graphql';
import Link from 'next/link';
import { useTranslate } from '@tolgee/react';
import { fromUnixTime } from 'date-fns';
import { formatDate } from '@amf/shared/utils/date';
import React from 'react';
import { getInitials } from '@amf/shared/utils/string';

type Props = {
  offense: OffenseFragment;
  prefixes: { offenses: string };
};

function OffenseListItem({ offense, prefixes }: Props) {
  const { t } = useTranslate();
  const dateCreated = fromUnixTime(offense.dateCreated);
  const banMatchDate = offense.banMatchDate ? fromUnixTime(offense.banMatchDate) : null;

  return (
    <Link href={`${prefixes.offenses}/${offense.id}`}>
      <a className='OffenseItem'>
        <div className='OffenseItem__photo'>
          {offense.player ? (
            <>
              {offense.player.photoUrl ? (
                <img src={offense.player.photoUrl} alt={offense.player.fullName} />
              ) : (
                <div>{getInitials(offense.player.givenName, offense.player.familyName)}</div>
              )}
            </>
          ) : offense.team ? (
            <>
              {offense.team.club.brandUrl ? (
                <img src={offense.team.club.brandUrl} alt={offense.team.name} />
              ) : (
                <div>{offense.team.name.charAt(0)}</div>
              )}
            </>
          ) : (
            <div />
          )}
        </div>
        <div className='OffenseItem__info'>
          <time className='OffenseItem__date'>{formatDate(dateCreated, 'dd. MM. yyyy')}</time>
          <h3 className='OffenseItem__type'>
            {offense.player?.fullName ?? offense.team?.name ?? '-'}
          </h3>
          {offense.event && offense.match ? (
            <p className='OffenseItem__description'>
              {t('offense.match', {
                season: offense.seasonName,
                league: offense.leagueName,
                round: offense.match.round,
                home: offense.match.home?.team.name ?? '-',
                away: offense.match.visiting?.team.name ?? '-',
                minute: offense.event.minute,
                score: offense.match.score,
              })}
            </p>
          ) : (
            <p className='OffenseItem__description'>
              {t('offense.match.plain', {
                season: offense.seasonName,
                league: offense.leagueName,
              })}
            </p>
          )}
        </div>
        <div className='OffenseItem__table'>
          <div className='OffenseItem__section'>
            <label>{t('offense.type')}</label>
            {offense.team && !offense.player ? (
              <strong>{t('offense.type.team')}</strong>
            ) : (
              <strong>
                {t(`offense.type.${offense.type}`)}{' '}
                {offense.banMatchCount && (
                  <>
                    ({t('offense.banMatchCount')}: {offense.banMatchCount})
                  </>
                )}
                {banMatchDate && (
                  <>
                    ({t('offense.banMatchTime')}): {formatDate(banMatchDate, 'dd. MM. yyyy')}
                  </>
                )}
              </strong>
            )}
          </div>
        </div>
      </a>
    </Link>
  );
}

export default OffenseListItem;
